import type { IntegrationsWebSite, LocalIntegrationsWebsite, LocalStorageFunctions } from './types';

const INTEGRATIONS_WEBSITE: string = 'integrations-website';

const getWebsite = (fn: LocalStorageFunctions) => () => fn.readObject<IntegrationsWebSite>(INTEGRATIONS_WEBSITE);
const setWebsite = (fn: LocalStorageFunctions) => (data: IntegrationsWebSite) => fn.writeObject(INTEGRATIONS_WEBSITE, data);

const integrationsWebSite = (fn: LocalStorageFunctions): LocalIntegrationsWebsite => ({
  getWebsite: getWebsite(fn),
  setWebsite: setWebsite(fn)
});

export default integrationsWebSite;
